{
    "Profile_Dwellings.dwellings": "FR: Dwellings",
    "Profile_Dwellings.dwelling": "FR: Dwelling {number}"
}
